// extracted by mini-css-extract-plugin
module.exports = {"user":"User-module--user--1hmzl","user__avatar":"User-module--user__avatar--3jupA"};